import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Suspense as _Suspense, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "app-layout" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_p_toast = _resolveComponent("p-toast")!

  return (_openBlock(), _createBlock(_Suspense, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.isSignedIn && !_ctx.isLoginPage)
          ? (_openBlock(), _createBlock(_component_NavBar, { key: 0 }))
          : _createCommentVNode("", true),
        _createElementVNode("main", {
          class: _normalizeClass(["main-content", { 
            'with-sidebar': _ctx.isSignedIn && !_ctx.isLoginPage,
            'container': !_ctx.isLoginPage 
          }])
        }, [
          _createVNode(_component_router_view)
        ], 2),
        _createVNode(_component_p_toast)
      ])
    ]),
    fallback: _withCtx(() => [...(_cache[0] || (_cache[0] = [
      _createElementVNode("div", { class: "loading-container" }, [
        _createElementVNode("div", { class: "loading-indicator" }),
        _createElementVNode("p", null, "Loading application...")
      ], -1)
    ]))]),
    _: 1
  }))
}